import React from 'react';
import Button, { buttonVariants } from '@weave-mui/button';
import StandardEmptyState from '../../components/StandardEmptyState';

/**
 * Empty state component displayed when there are no global fields
 * @param {Object} props - Component props
 * @param {Function} props.onCreateGlobalField - Callback function when Create Global Field button is clicked
 */
const EmptyGlobalFieldsState = ({ onCreateGlobalField }) => {
  return (
    <StandardEmptyState
      headline="No global fields yet"
      tagline="Create global fields to reuse data across your test cases"
      callToAction={
        <Button variant={buttonVariants.CONTAINED} onClick={onCreateGlobalField}>
          Create Global Field
        </Button>
      }
    />
  );
};

export default EmptyGlobalFieldsState;

